
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';
import { Info } from 'lucide-react';

const ToursEmpty: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <Card className="text-center py-10">
      <CardContent className="flex flex-col items-center gap-4">
        <Info className="h-12 w-12 text-muted-foreground" />
        <div>
          <p className="text-lg font-medium">{t('no_tours')}</p>
          <p className="text-gray-600 mt-2">{t('check_back_later')}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ToursEmpty;
